package game.scenes;


import cerastes.flow.Flow.JumpNode;
import cerastes.SoundManager;
import cerastes.Timer;
import cerastes.Utils;
import hxd.Key;
import cerastes.c2d.DebugDraw;


@:keep
class TitleCardScene extends LDScene
{

	@:obj var txtTitle: h2d.Text;
	@:obj var txtSub: h2d.Text;

	public static var title: String = "";
	public static var subtitle: String = "";

	public static var jumpFile: String = "";
	public static var jumpTarget: String = null;

	public static function setTitle(t: String, s: String )
	{
		title = t;
		subtitle = s;
	}

	public static function setJumpTarget(file: String, node: String = null )
	{
		jumpFile = file;
		jumpTarget = node;
	}

	override function enter()
	{
		super.enter();

		ui = hxd.Res.ui.titlecard.toObject(s2d);

		var root = s2d;
		cerastes.macros.UIPopulator.populateObjects();

		txtTitle.text = title;
		txtSub.text = subtitle;

		SoundManager.playMusicFile(null);


		new Timer(5, () -> {
			GameState.flow.jumpFile(jumpFile, jumpTarget);
		});
	}



	override function tick( delta:Float )
	{
		super.tick(delta);
	}

	override function exit()
	{
		super.exit();
	}


	override function preload()
	{
		super.preload();
	}
}
